import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const Wrapper = styled.div``

export const Header = styled.div`
  display: flex;
  align-items: center;

  h2 {
    font-size: 25px;
    color: #828282;
    font-weight: 400;
  }

  Button {
    background-color: ${theme.colors.white};
    width: 10%;
    height: 10%;
    border-radius: 0 0 0 0;
    svg {
      path {
        fill: ${theme.colors.black};
      }
    }
  }
  .date-select {
    margin-left: 50%;
    margin-bottom: 20px;
    label {
      &::after {
        content: '';
        position: absolute;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        // border-top: 8px solid ${theme.colors.darkGray};
        border-radius: 6px;
        font-size: 2px;
        margin-left: 15px;
        right: 18px;
        top: 25px;
        pointer-events: none;
      }
    }
  }
`
export const Body = styled.div``
export const DataContainer = styled.div`
  > div {
    margin-top: 2em;
  }
  table {
    width: 100%;
    th {
      box-shadow: 0 2px 2px 0;
    }
    td {
      padding: 0.5%;
      word-break: keep-all;
    }
  }
`
